import React from 'react';
import styles from '../styles.scss';
import { FormattedMessage } from 'react-intl';
import Radio from 'hellospa/foundation/control/radio';
import gmailSvg from './assets/Google.svg';
import yahooSvg from './assets/Yahoo.svg';
import Spacer, { SpacerSize } from 'hellospa/foundation/spacing/spacer';
import Body, { BodyType } from 'hellospa/foundation/typography/body';
import { Source } from '.';
import Button, { ButtonType } from 'hellospa/foundation/control/button';
import HelloModal from 'common/components/hello-modal';
import { trackHeapCustomEvent } from 'common/utils/heap';

type SourceProps = {
  onRequestClose: () => void,
  nextStep: (source: Source) => void
}
export function ChooseSource({ onRequestClose, nextStep }: SourceProps) {
  const [source, setSource] = React.useState<Source | undefined>();

  return (
    <HelloModal
      isOpen={true}
      showCloseIcon={true}
      contentLabel={

        <FormattedMessage
          id=""
          defaultMessage={'Import Contacts'}
          description={'header text in modal, providing user options to import contacts from third party app'} />
      }
      onRequestClose={onRequestClose}
      buttons={[
        <Button
          key="import"
          kind={ButtonType.Primary}
          disabled={source === undefined}
          onClick={() => {
            if (source) {
              trackHeapCustomEvent('Source Selected', { Source: source });
              nextStep(source);
            }
          }}
        >
          <FormattedMessage
            id=""
            defaultMessage="import"
            description="Import button on the import contacts modal" />
        </Button>,
      ]
      }
    >


      <div className={styles.sourceList}>
        <Spacer below={SpacerSize.MD}>
          <Body kind={BodyType.Large}>
            <FormattedMessage
              id=""
              defaultMessage={'Choose a source to import your contacts from.'}
              description={'text in modal, providing user options to import contacts from third party app'} />
          </Body>
        </Spacer>

        <Spacer below={SpacerSize.MD}>
          <Radio
            checked={source === 'gmail'}
            onChange={() => setSource(Source.Gmail)}
            id="gmail"
            name="source"
            value="1" />
          <label htmlFor="gmail">
            <img className={styles.logo} src={gmailSvg} alt="Google logo" />
          </label>
        </Spacer>
        <Spacer below={SpacerSize.MD}>
          <Radio
            checked={source === 'yahoo'}
            onChange={() => setSource(Source.Yahoo)}
            id="yahoo"
            name="source"
            value="1" />
          <label htmlFor="yahoo">
            <img className={styles.logo} src={yahooSvg} alt="Yahoo! logo" />
          </label>
        </Spacer>

      </div>
    </HelloModal>
  );
}
